import { gql } from "apollo-angular";

export var GET_FUND_ROLES = gql`
  query getRolesByRoleType($role: String!){
    roles_by_role_type_name(name: $role){
      roles {
        id
        name
        roleType {
          name
          id
        }
      }
    }
  }
  `
